// extracted by mini-css-extract-plugin
export default {"img":"NotFoundPage_img__i+7oZ","filter":"NotFoundPage_filter__B93aI","container":"NotFoundPage_container__L5jX7"};